<template>
  <section>
    <b-field v-if="false">
      <b-button
        v-if="selected"
        type="is-danger"
        icon-left="close"
        :disabled="!selected"
        label="Clear selected"
        @click="selected = null"
      />
    </b-field>

    <b-table
      focusable
      :data="data"
      :striped="true"
      :bordered="true"
      @click="handleClick"
      :per-page="perPage"
      :paginated="isPaginated"
      :current-page.sync="currentPage"
      :pagination-order="paginationOrder"
      :pagination-simple="isPaginationSimple"
      :pagination-position="paginationPosition"
      :sort-icon="sortIcon"
      default-sort="totalAppTime"
      :sort-icon-size="sortIconSize"
      :default-sort-direction="defaultSortDirection"
    >
      <b-table-column
        v-slot="props"
        v-for="column in columns"
        :key="column.field"
        :field="column.field"
        :label="column.label"
        :sortable="column.sortable"
      >
        {{
          column.field === "totalDuration" || column.field === "totalAppTime"
            ? formatTotalDurationColumn(props.row[column.field])
            : props.row[column.field]
        }}
      </b-table-column>
    </b-table>
  </section>
</template>

<script>
import moment from "moment";
import { mapMutations, mapState } from "vuex";

export default {
  props: {
    learnerDetailsData: Array,
    learnerEngagementsData: Array
  },
  computed: {
    ...mapState({
      reflectiveData: state => state.globalStore.reflectiveData
    }),
    data() {
      return this.learnerEngagementsData.map(activeLearner => {
        let userDetails = this.learnerDetailsData.find(
          user => user._id == activeLearner.uid
        );

        return {
          uid: userDetails._id,
          email: userDetails.email,
          lastName: userDetails.lastName,
          firstName: userDetails.firstName,
          totalDuration: activeLearner.totalDuration,
          totalAppTime: activeLearner.totalAppTime,
          numActiveDays: activeLearner.activeDates.length,
          lastDayActive: moment(
            activeLearner.activeDates.slice(-1)[0].eventDate.value
          ).format("MMM Do YY")
        };
      });
    }
  },
  methods: {
    ...mapMutations({
      isModalActive: "globalStore/updateIsLearnerModalActive",
      updateActiveUser: "globalStore/updateActiveUser"
    }),
    handleClick(selectedRow) {
      const userDetails = this.reflectiveData.find(
        learner => learner._id == selectedRow.uid
      );
      this.isModalActive(true);
      this.updateActiveUser(userDetails);
    },
    formatTotalDurationColumn(totalTime) {
      return totalTime / 60 > 60
        ? `${(totalTime / 3600).toFixed(2)} hrs`
        : `${(totalTime / 60).toFixed(2)} mins`;
    }
  },
  data() {
    return {
      perPage: 25,
      currentPage: 1,
      paginationOrder: "desc",

      isPaginated: true,
      isPaginationSimple: true,
      paginationPosition: "bottom",

      sortIcon: "arrow-down",
      sortIconSize: "is-small",
      defaultSortDirection: "asc",

      selectedLearner: null,

      columns: [
        {
          field: "email",
          label: "Email",
          sortable: true
        },
        {
          field: "firstName",
          label: "First Name"
        },
        {
          field: "lastName",
          label: "Last Name"
        },
        {
          field: "numActiveDays",
          label: "Num of days active"
        },
        {
          field: "totalDuration",
          label: "Total Learning Time",
          sortable: true
        },
        {
          field: "totalAppTime",
          label: "Total App Time",
          sortable: true
        },
        {
          field: "lastDayActive",
          label: "Last Active",
          centered: true
        }
      ]
    };
  }
};
</script>
